import { createGlobalStyle } from 'styled-components';

export const colors = {
  primary: '#1E1E1E',
  secondary: '#FFFFFF',
  active: 'rgba(0, 183, 255, 0.9)',
  active2: 'rgba(0, 68, 255, 0.9)',
};

export const ColorMixin = {};
Object.keys(colors).forEach((key) => {
  ColorMixin[key] = colors[key];
});

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 62.5%;
  }

  html, body, #__next {
    height: 100%;
  }

  body {
    font-family: 'Outfit', sans-serif;
    background-color: ${ColorMixin.primary};
    margin: auto;
    color: ${ColorMixin.secondary};
    width: 100%;
    padding: 20px;

    p {
      line-height: 1.5;
    }

    @media screen and (min-width: 1025px){
      width: 85%;
      max-width: 1920px;
    }
  }

`;

export default GlobalStyle;
